import { Badge } from "@/components/ui/badge";

const variant = {
  platform_admin: "default" as const,
  tenant_admin: "secondary" as const,
  tenant_viewer: "outline" as const,
};

const label = {
  platform_admin: "Platform Admin",
  tenant_admin: "Tenant Admin",
  tenant_viewer: "Tenant Viewer",
};

export function RolePill({ role }: { role: string }): JSX.Element {
  const v = variant[role as keyof typeof variant] ?? "muted";
  const l = label[role as keyof typeof label] ?? role;
  return (
    <Badge variant={v} className="capitalize">
      {l}
    </Badge>
  );
}
